import React from 'react';
import { Tag, Tooltip, Typography } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import { useTranslation } from '../../i18n';
import { userPath } from '../../config/paths';

// CDN 套餐限制(后端 DomainController::getGet → domainData.plan_limits):
//   cache.level = basic | advanced | full;cache.fields = 控件 → 需要的级别;log_retention_days = 可查日志天数
const RANK = { basic: 0, advanced: 1, full: 2 };

// 拿不到套餐信息时不锁(后端仍会校验)
export const cacheLevel = (domainData) => domainData?.plan_limits?.cache?.level || 'full';
export const planAllows = (domainData, need) => (RANK[cacheLevel(domainData)] ?? 2) >= (RANK[need] ?? 0);
export const fieldNeed = (domainData, field) => domainData?.plan_limits?.cache?.fields?.[field] || 'basic';
export const fieldLocked = (domainData, field) => !planAllows(domainData, fieldNeed(domainData, field));

/** 小「升级」标签:悬停说明所需级别,点击进入该域名的套餐页。 */
export function UpgradeTag({ need = 'advanced' }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { domainName } = useParams();
  const tip = need === 'full' ? t('Requires the Full cache plan') : t('Requires the Advanced cache plan');
  return (
    <Tooltip title={tip}>
      <Tag
        color="gold"
        style={{ marginLeft: 6, cursor: domainName ? 'pointer' : 'default', fontWeight: 'normal' }}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          if (domainName) navigate(userPath(`/cdn/domains/${domainName}/plan`));
        }}
      >
        {t('Upgrade')}
      </Tag>
    </Tooltip>
  );
}

/** 控件需要的级别不够时显示 UpgradeTag,否则不显示。 */
export function PlanTag({ domainData, need }) {
  if (!need || planAllows(domainData, need)) return null;
  return <UpgradeTag need={need} />;
}

// ── 日志保留 ──
export const retentionDaysOf = (domainData) => Number(domainData?.plan_limits?.log_retention_days) || null;

/** RangePicker disabledDate:保留期之前和今天之后不可选。 */
export const retentionDisabledDate = (days) => (current) => {
  if (!days || !current) return false;
  return current.isBefore(dayjs().subtract(days, 'day').startOf('day')) || current.isAfter(dayjs().endOf('day'));
};

/** 把已选范围夹到保留期内(起点早于保留期 → 挪到保留期起点)。 */
export const clampRange = (range, days) => {
  if (!days || !Array.isArray(range) || !range[0]) return range;
  const floor = dayjs().subtract(days, 'day');
  return range[0].isBefore(floor) ? [floor, range[1]] : range;
};

export function RetentionHint({ days }) {
  const { t } = useTranslation();
  if (!days) return null;
  return (
    <Typography.Text type="secondary" style={{ fontSize: 12 }}>
      {t('Logs kept for {{days}} days', { days })}
    </Typography.Text>
  );
}
